import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportGatewayService } from '../../../pages/report-gateway/services/report-gateway.service';
import { UtilityService } from '../../../core/services/utility.service';

import {
  PdfViewerComponent,
  LinkAnnotationService,
  BookmarkViewService,
  MagnificationService,
  ThumbnailViewService,
  ToolbarService,
  NavigationService,
  SignatureFieldSettings,
  AnnotationService,
  TextSearchService,
  TextSelectionService,
  PrintService,
  FormDesignerService,
  FormFieldsService,
  ValidateFormFieldsArgs,
} from '@syncfusion/ej2-angular-pdfviewer';

@Component({
  selector: 'app-view-attachment',
  templateUrl: './view-attachment.component.html',
  styleUrls: ['./view-attachment.component.css'],
  providers: [
    LinkAnnotationService,
    BookmarkViewService,
    MagnificationService,
    ThumbnailViewService,
    ToolbarService,
    NavigationService,
    SignatureFieldSettings,
    AnnotationService,
    TextSearchService,
    TextSelectionService,
    PrintService,
    FormDesignerService,
    FormFieldsService,
  ],
})
export class ViewAttachmentComponent implements OnInit {
  @Input() attachmentId: string;
  @Input() rid: string;
  @Input() rsid: string;
  public pdfviewerControl: PdfViewerComponent;
  showViewer = false;
  alert: any;
  fileName: string;
  service: any;
  mobileMode = false;
  pdfResource: any;
  constructor(
    public activeModal: NgbActiveModal,
    public HttpClient: HttpClient,
    private modalService: NgbModal,
    private reportGatewayService: ReportGatewayService,
    private utilityService: UtilityService
  ) {
    this.mobileMode = utilityService.isMobileMode();
  }

  ngOnInit(): void {
    this.service = '/Api/PdfViewer';
    this.pdfResource = window.location.origin + '/dist/assets/ej2-pdfviewer-lib';
    this.reportGatewayService
      .getVistaAttachment(this.attachmentId, this.rid, this.rsid)
      .then((response: any) => {
        if (!response.IsError) {
          this.showViewer = true;
          this.fileName = response.FileName;
          setTimeout(() => {
            var pdfviewer = (<any>document.getElementById('pdfViewerModal')).ej2_instances[0];
            setTimeout(() => {
              pdfviewer.toolbar.showToolbarItem(new Array('SubmitForm'), false);
              pdfviewer.toolbar.showToolbarItem(new Array('OpenOption'), false);
              pdfviewer.toolbar.showToolbarItem(new Array('PrintOption'), true);
              pdfviewer.toolbar.showToolbarItem(new Array('AnnotationEditTool'), false);
              pdfviewer.toolbar.showToolbarItem(new Array('FormDesignerEditTool'), false);
              if (!this.mobileMode) {
                pdfviewer.toolbar.showToolbarItem(new Array('CommentTool'), false);
                pdfviewer.toolbar.showToolbarItem(new Array('UndoRedoTool'), false);
              }
              pdfviewer.documentPath = 'data:application/pdf;base64,' + response.FileData;
              pdfviewer.downloadFileName = this.fileName;
            }, 2000);
          }, 1000);
        } else {
          this.alert = { type: response.IsError ? 'danger' : 'warning', msg: response.Error };
        }
      })
      .catch((error: any) => {});
  }

  public closeClicked() {
    this.activeModal.close();
  }

  public closeAlert() {
    this.alert = null;
  }
}
